<template>
  <main>
    <v-toolbar style="background-color: #444; color: #fff; border-radius: 5px">
      <v-toolbar-title>
        {{ $t("daily_program") }}
      </v-toolbar-title>
    </v-toolbar>
    <v-form @submit.prevent="handleSubmit" class="mt-5">
      <formWrapper :validator="$v.form">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                clearable
                multiple
                chips
                small-chips
                deletable-chips
                :items="places"
                item-text="name"
                item-value="id"
                dense
                :label="$t('fields.places')"
                outlined
                v-model="form.places"
              ></v-autocomplete>
            </v-col>
            <!-- <v-col cols="12" md="6" lg="6">
              <v-autocomplete
                clearable
                multiple
                chips
                small-chips
                deletable-chips
                :items="features"
                item-text="name"
                item-value="id"
                dense
                :label="$t('fields.features')"
                outlined
                v-model="form.features"
              ></v-autocomplete>
            </v-col> -->
            <v-col cols="12">
              <form-group name="description" attribute="fields.description">
                <template slot-scope="{ attrs, listeners }">
                  <v-textarea
                    outlined
                    no-resize
                    :rows="3"
                    :placeholder="$t('fields.description')"
                    v-model="form.description"
                    v-on="listeners"
                    v-bind="attrs"
                  />
                </template>
              </form-group>
            </v-col>
            <v-col cols="12">
              <form-group name="hint" attribute="fields.hint">
                <template slot-scope="{ attrs, listeners }">
                  <v-textarea
                    outlined
                    no-resize
                    :rows="3"
                    :placeholder="$t('fields.hint')"
                    v-model="form.hint"
                    v-on="listeners"
                    v-bind="attrs"
                  />
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" lg="2">
              <v-btn
                :disabled="$v.form.$invalid"
                :loading="loadingButton"
                type="submit"
                class="secondary"
                large
                block
                rounded
                >{{ $t("button.save") }}
                <v-icon>mdi-content-save</v-icon></v-btn
              >
            </v-col>
            <v-col cols="12" lg="2" v-if="program && program.id">
              <v-btn
                :loading="removeLoading"
                @click="handleRemove"
                type="button"
                class="error"
                large
                block
                rounded
                >{{ $t("button.remove_program") }}
                <v-icon>mdi-delete</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </formWrapper>
    </v-form>
  </main>
</template>

<script>
import { minLength, required } from "vuelidate/lib/validators";
import { maxWords } from "@/utils/validate";
import { IndexData, StoreData } from "@/helpers/apiMethods";
export default {
  name: "DailyProgram",
  props: {
    program: {
      type: Object,
      default: () => {}
    },
    locale: {
      type: String,
      default: "en"
    }
  },
  data() {
    return {
      loadingButton: false,
      places: [],
      features: [],
      removeLoading: false,
      form: {
        description: "",
        hint: "",
        places: [],
        features: []
      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    resetData() {
      for (const key in this.form) {
        if (typeof this.form[key] !== "object") {
          this.form[key] = "";
        } else {
          this.form[key] = [];
        }
      }
      this.$v.form.$reset();
    },
    handleRemove() {
      this.popUp().then(value => {
        if (!value.dismiss) {
          this.removeLoading = true;
          StoreData({
            reqName: `trips/${this.$route.params.slug}/daily-programs/${this.form.id}`,
            data: { _method: "delete" }
          })
            .then(() => {
              this.resetData();
            })
            .finally(() => {
              this.removeLoading = false;
            });
        }
      });
    },
    assignValue(program) {
      this.form = {
        ...program,
        places: program.places.map(place => place.id),
        features: program.features.map(feature => feature.id)
      };
    },
    generateData() {
      const formData = new FormData();
      for (const key in this.form) {
        if (typeof this.form[key] !== "object" && this.form[key] !== "") {
          formData.append(key, this.form[key]);
        }
      }
      this.form.places.length > 0
        ? this.form.places.map(place => {
            formData.append(`places[]`, place);
          })
        : formData.append(`places[]`, []);
      this.form.features.length > 0
        ? this.form.features.map(feature => {
            formData.append(`features[]`, feature);
          })
        : formData.append(`features`, "''");
      formData.append("hint", this.form.hint ? this.form.hint : "");

      if (this.form.id) {
        formData.append("_method", "put");
        formData.append("locale", this.locale);
      }
      return formData;
    },

    onUpdate() {
      StoreData({
        reqName: `trips/${this.$route.params.slug}/daily-programs/${this.form.id}`,
        data: this.generateData()
      }).finally(() => {
        this.loadingButton = false;
      });
    },
    onCreate() {
      StoreData({
        reqName: `trips/${this.$route.params.slug}/daily-programs`,
        data: this.generateData()
      })
        .then(res => {
          const { daily_program } = res.data;
          this.assignValue(daily_program);
        })
        .finally(() => {
          this.loadingButton = false;
        });
    },
    handleSubmit() {
      this.loadingButton = true;
      if (this.form.id) {
        // in case update
        this.onUpdate();
      } else {
        // in case create
        this.onCreate();
      }
    },
    getData() {
      const fields = ["places"];
      for (const field of fields) {
        IndexData({ reqName: field, query: { pagination: "all" } }).then(
          res => {
            const data = res.data[field];
            this[field] = data;
          }
        );
      }
    }
  },
  validations() {
    return {
      form: {
        description: {
          required,
          minLength: minLength(50),
          maxWords: maxWords(300)
        },
        hit: {
          minLength: minLength(3),
          maxWords: maxWords(150)
        }
      }
    };
  },
  watch: {
    program: {
      handler(value) {
        if (value && value.id) {
          this.assignValue(value);
        }
      },
      immediate: true
    }
  }
};
</script>
